module.exports = __webpack_public_path__ + "img/signs.5b80dd5.c37e3388.png";